import { render, staticRenderFns } from "./04_bed_spread.vue?vue&type=template&id=42740cb0&scoped=true&"
import script from "./04_bed_spread.vue?vue&type=script&lang=js&"
export * from "./04_bed_spread.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42740cb0",
  null
  
)

export default component.exports